import store from '@/store/index'

export default {}

/**
 * Returns all of the user's settings or a specific setting.
 * Specify '*' for the name if you want all the properties
 * returned.
 *
 * @param name String
 * @param defaultValue mixed
 *
 * @return mixed
 */
export const get = (name = '*', defaultValue = null) => {
  if (name === '*') {
    return store.getters[`settings/get`]
  } else {
    const settings = store.getters[`settings/get`]
    if (settings.hasOwnProperty(name)) {
      return settings[name]
    } else {
      return defaultValue
    }
  }
}

/**
 * Set all settings.
 *
 * @param properties Object
 */
export const setAll = (properties) => {
  store.commit(`settings/setAll`, properties)
}

/**
 * Set a property's value
 *
 * @param name String
 * @param value mixed
 */
export const set = (name, value) => {
  store.commit(`settings/set`, { name, value })
}

/**
 * Load the user's settings from the backend API into
 * the store.
 *
 * @return Promise
 */
export const load = () => {
  return store.dispatch(`settings/fetch`)
}

/**
 * Save the current settings to the backend API
 *
 * @return Promise
 */
export const save = () => {
  return store.dispatch(`settings/put`)
}



// WEBPACK FOOTER //
// ./src/store/accounts/usersSettings.helpers.js